import styled from "styled-components"
import { LinkButton } from "client/components"

export const Datapoint = styled.div`
    display: flex;
    flex-direction: column;
    margin: 15px 15px 20px 15px;
    border: 1px solid ${(props) => props.theme.qidDatapointBorderColor};
`
export const DatapointDetails = styled.div`
    position: relative;
    padding: 10px;
    padding-bottom: 0;
    background: ${(props) => props.theme.qidDatapointTitleBackground};
`
export const DatapointTitle = styled.span`
    margin-bottom: 3px;
    margin-left: 10px;
`
export const DatapointButtons = styled.div`
    display: flex;
    flex-direction: row;
    position: absolute;
    top: 10px;
    right: 10px;
    
    & > ${LinkButton} {
        margin-right: 15px;
    }
`
